import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, filter, of, take, tap } from 'rxjs';

import * as CatalogActions from '@core/state/catalog/catalog.actions';
import * as fromCatalog from '@core/state/catalog/catalog.selectors';

@Injectable({
  providedIn: 'root'
})
export class CatalogContentfulBannerResolver  {
  constructor( private store: Store){}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    
    this.store.dispatch(CatalogActions.getContentfulBanner());

    return this.store.pipe(
      select(fromCatalog.selectCatalogContentfulBanner), // Assuming you have a selector to check if banners are loaded
      filter(loaded => !!loaded), // Wait until the banners are loaded (loaded is true)
      take(1), // Complete the observable after the condition is met
    );

  }
}
